import { useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { RenderApp, renderViewer } from './routes/Routes';
import { GOOGLE_OAUTH_CONFIG } from './config/googleOAuth';

const App = () => {
  const routePaths = useLocation().pathname.split('/');
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    console.log('Application initialized - Hostname:', window.location.hostname);
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CONFIG.clientId}>
      {routePaths[1] === 'viewers' || routePaths[1] === 'redir'
        ? renderViewer()
        : RenderApp(location, params)}
    </GoogleOAuthProvider>
  );
};

export default App;
